export const animals = [
  {
    id: 'chicken',
    name: 'Chicken',
    productionTime: 1800, 
    productionsPerHarvest: {
      common: 1,
      uncommon: 2,
      rare: 4,
      epic: 8,
      legendary: 16,
    },
  },
  {
    id: 'cow',
    name: 'Cow',
    productionTime: 6600, 
    productionsPerHarvest: {
      common: 1,
      uncommon: 2,
      rare: 4,
      epic: 8,
      legendary: 16,
    },
  },
  {
    id: 'alpaga',
    name: 'Alpaga',
    productionTime: 13800, // 3 hours
    productionsPerHarvest: {
      common: 1,
      uncommon: 2,
      rare: 4,
      epic: 8,
      legendary: 16,
    },
  },
  // ... add more animals
];
